import alertConstants from '../constants';

export function alert(state = {}, action) {
    switch (action.type) {
        case alertConstants.SUCCESS:
        case alertConstants.WARN:
        case alertConstants.ERROR:
        case alertConstants.INFO:
            return {
                type: action.type,
                message: action.message,
                callback: action.callback
            };
        case alertConstants.CLEAR:
            return {};
        default:
            return state;
    }
}